var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.title,domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-fluid"})])}
var staticRenderFns = []

export { render, staticRenderFns }